import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControlValueAccessor } from '../../../../../shared/abstract_control_value_accessor.abstract';
import {
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  UntypedFormControl,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { Settings } from '../../../../../core/_models/settings';
import { Subscription } from 'rxjs';
import { IdentifierType, MemberIdentifier } from '../../../../../core/_models/member-interface';
import { MsisdnInputComponent } from '@app/shared/components/msisdn-input/msisdn-input.component';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AppFocusableDirective } from '@app/shared/directives/focusable.directive';

@Component({
  selector: 'app-identifier-input',
  templateUrl: './identifier-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => IdentifierInputComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => IdentifierInputComponent), multi: true },
  ],
  imports: [
    MsisdnInputComponent,
    NgClass,
    TranslatePipe,
    ReactiveFormsModule,
    AppFocusableDirective,
  ],
})
export class IdentifierInputComponent extends AbstractControlValueAccessor implements OnInit, AfterViewInit, OnDestroy, Validator {
  @Input() public settings: Settings;
  @Input() public showErrors: boolean;
  @Input() public formErrors: any = {};
  @Input() public readonly = false;
  @Output() public editClicked = new EventEmitter<boolean>();
  public formControl = new UntypedFormControl('');
  public identifiersEnabled = ['msisdn'];
  private formSub: Subscription;

  public ngOnInit(): void {
    if (this.settings.schema.identifiers) { this.identifiersEnabled = this.settings.schema.identifiers; }

    this.formSub = this.formControl.valueChanges.subscribe(() => this.onFormChange());
  }

  public ngAfterViewInit(): void {
    this.onFormChange();
  }

  public ngOnDestroy(): void {
    this.formSub.unsubscribe();
  }

  public writeValue(obj: any): void {
    this.formControl.setValue(obj);
  }

  public validate(): ValidationErrors | any {
    return this.formControl.errors;
  }

  private onFormChange(): void {
    const memberIdentifier: MemberIdentifier = {
      identifier_type: IdentifierType[this.identifiersEnabled[0].toUpperCase()],
      identifier: this.formControl.value,
    };

    this.formErrors = null;

    this.onTouched();
    this.onChange(memberIdentifier);
  }
}
